export default "__VITE_ASSET__Dtf$PpXu__"